import { render } from "./videoPopup_new.vue?vue&type=template&id=7c86ac39&scoped=true"
import script from "./videoPopup_new.vue?vue&type=script&lang=js"
export * from "./videoPopup_new.vue?vue&type=script&lang=js"

import "./videoPopup_new.vue?vue&type=style&index=0&id=7c86ac39&lang=scss&scoped=scoped"

import exportComponent from "/Users/cw/Desktop/BME/screen_project_315/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7c86ac39"]])

export default __exports__